<div
    class="chat-bubble-container"
    [ngClass]="!alignRight() ? 'chat-bubble-container--left' : 'chat-bubble-container--right'"
    data-testid="container"
>
    <ng-content></ng-content>
</div>
